import { render, staticRenderFns } from "./SelectStatusColeta.vue?vue&type=template&id=84088466&scoped=true&"
import script from "./SelectStatusColeta.vue?vue&type=script&lang=ts&"
export * from "./SelectStatusColeta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84088466",
  null
  
)

export default component.exports